import { PropsWithChildren } from 'react';

import { Loading } from 'scbk-ui-web';

const EmptyChannelInitializer: React.FC<PropsWithChildren> = () => {
    return <Loading loading={true} message="EmptyChannelInitializer Loading" />;
};

export { EmptyChannelInitializer };
